module.exports = __webpack_public_path__ + "static/media/icon-adherence-issue-off.ee7746dc.svg";